export const LOAD_PORTFOLIO_CONTACT_BOOK = 'portfolio-contacts/LOAD_PORTFOLIO_CONTACT_BOOK';
export const ADD_PORTFOLIO_CONTACT = 'portfolio-contacts/ADD_PORTFOLIO_CONTACT';
export const SAVE_PORTFOLIO_CONTACT = 'portfolio-contacts/SAVE_PORTFOLIO_CONTACT';
export const DELETE_PORTFOLIO_CONTACT = 'portfolio-contacts/DELETE_PORTFOLIO_CONTACT';